import React from "react";
import { Check, X } from "lucide-react";

export const scorePassword = (pw) => {
  if (!pw) return 0;
  let s = 0;
  if (pw.length >= 8) s++;
  if (pw.length >= 12) s++;
  if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) s++;
  if (/\d/.test(pw)) s++;
  if (/[^A-Za-z0-9]/.test(pw)) s++;
  return Math.min(s, 4);
};

const LABELS = ["Too short", "Weak", "Moderate", "Good", "Strong"];
const COLORS = ["bg-slate-300", "bg-rose-500", "bg-amber-500", "bg-lime-500", "bg-emerald-500"];
const TEXT = ["text-slate-400", "text-rose-600", "text-amber-600", "text-lime-600", "text-emerald-600"];

const PasswordStrength = ({ password }) => {
  if (!password) return null;
  const score = scorePassword(password);
  const min = password.length >= 8;
  return (
    <div className="mt-2">
      <div className="flex gap-1.5">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className={`h-1.5 flex-1 rounded-full transition-colors ${i < score ? COLORS[score] : "bg-slate-200"}`} />
        ))}
      </div>
      <div className="mt-1.5 flex items-center justify-between text-xs">
        <span className={`font-medium ${TEXT[score]}`}>{LABELS[score]}</span>
        <span className={`inline-flex items-center gap-1 ${min ? "text-emerald-600" : "text-slate-400"}`}>
          {min ? <Check className="h-3.5 w-3.5" /> : <X className="h-3.5 w-3.5" />} Min 8 characters
        </span>
      </div>
    </div>
  );
};

export default PasswordStrength;
